import "./Logo.css";
import headerLogo from "../../images/logo.svg";

function Logo() {

  return (
    <div className="logo appear fontoptimisation">
      <img
        className="logo__image"
        src={headerLogo}
        alt="Логотип РЭК"
      />
      <p className="logo__title">Региональная</p>
      <p className="logo__subtitle">Энергетическая</p>
      <p className="logo__subtitle">Компания</p>
    </div>
  );
}

export default Logo;
